// extracted by mini-css-extract-plugin
export default {"paragraph":"Resume_paragraph__XhvZF","imageBackground":"Resume_imageBackground__a7aK4","card_text":"Resume_card_text__OMxDL","resume_title":"Resume_resume_title__8lm6E"};